import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { UserView } from "./UserView";
import { UserViewStore } from "../../store/UserViewStore";
import { useStore } from "../../../../hooks";

export const UserViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/user/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new UserViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [
            { id: "main", label: rootStore.langStore.groupUserMainLabel },
            { id: "details", label: rootStore.langStore.groupUserDetailsLabel },
          ],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <UserView userViewStore={store} />
      </PageLayout>
    </div>
  );
});
